module.exports = __webpack_public_path__ + "static/current-projects.1fa60740.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/current-projects.svg
// module id = 285
// module chunks = 35783957827783 277036910692064